var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18C6.10457 18 7 17.1046 7 16C7 14.8954 6.10457 14 5 14C3.89543 14 3 14.8954 3 16C3 17.1046 3.89543 18 5 18Z",
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18C19.1046 18 20 17.1046 20 16C20 14.8954 19.1046 14 18 14C16.8954 14 16 14.8954 16 16C16 17.1046 16.8954 18 18 18Z",
    fill: "#6C65F7",
    fillOpacity: 0.16,
    stroke: "#6C65F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H16",
    stroke: "#6C65F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16H1.15612C1.0699 16 1 15.9301 1 15.8439V13.9897C1 12.6682 1.16207 11.3517 1.48257 10.0697V10.0697C1.80106 8.79577 2.79577 7.80106 4.06973 7.48257L4.59785 7.35054C5.5291 7.11772 6.48539 7 7.4453 7V7C9.76315 7 12.0291 7.68608 13.9577 8.97179L16.8629 10.9086C16.953 10.9687 17.056 11.007 17.1635 11.0204L20.8514 11.4814C20.9488 11.4936 21.0413 11.531 21.1198 11.5899V11.5899C22.3034 12.4776 23 13.8707 23 15.3502V15.4194C23 15.74 22.74 16 22.4194 16H20",
    stroke: "#6C65F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V10C9 10.5523 9.44772 11 10 11H17.2627",
    stroke: "#6C65F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7C10.6301 7 12.2238 7.48252 13.5801 8.38675L17.5 11H17.7627H10.5C9.94772 11 9.5 10.5523 9.5 10V7",
    fill: "#6C65F7",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarActive);
export default __webpack_public_path__ + "static/media/car-active.d4f12aefb6851f504a88f22bc84ddf16.svg";
export { ForwardRef as ReactComponent };